<template>
  <div class="pageContent">
    <div class="contnet">
      <p style="text-align:right;padding-right:20px">
        <img
          class="close"
          @click="closeFn"
          src="@/assets/close.svg"
          alt
        />
      </p>
      <div>
        <header
          class="header"
          style="font-family: '微软雅黑'"
        >
          <img
            class="image"
            src="@/assets/yuzhong.jpg"
            alt
          />
          <div
            class="hospital"
            style="letter-spacing: 0.1rem;"
          >{{reportInfo.institution_name}}</div>
          <div class="reportCard">{{reportInfo.exam_class}}检查报告单</div>
          <p class="CTNum">{{reportInfo.exam_class}}号:{{reportInfo.accession_num}}</p>
        </header>
        <section
          class="reportInfo"
          style="border-top:0.02rem solid #000;"
        >
          <div class="reportDetails">
            <div>
              <span class="label">姓名:</span>
              <span class="value">{{reportInfo.name}}</span>
            </div>
            <div>
              <span class="label">性别:</span>
              <span
                class="value"
                v-if="reportInfo.sex == 'F' || reportInfo.sex == '女'"
              >女</span>
              <span
                class="value"
                v-if="reportInfo.sex == 'M' || reportInfo.sex == '男'"
              >男</span>
            </div>
            <div>
              <span class="label">年龄:</span>
              <span class="value">{{reportInfo.age}}</span>
            </div>
            <div>
              <span class="label">检查日期:</span>
              <span class="value">{{reportInfo.exam_datetime}}</span>
            </div>
            <!-- <div>
              <span class="label">病历号:</span>
              <span class="value">{{reportInfo.patient_num}}</span>
            </div>-->
          </div>
        </section>
        <section class="reportInfo">
          <div class="reportDetails">
            <!-- <div>
              <span class="label">门诊号:</span>
              <span class="value">{{reportInfo.out_patient}}</span>
            </div>-->
            <div>
              <span class="label">住院号:</span>
              <span class="value">{{reportInfo.hopitalized_no}}</span>
            </div>
            <div>
              <span class="label">床号:</span>
              <span class="value">{{reportInfo.bed_no}}</span>
            </div>
            <div>
              <span class="label">科别:</span>
              <span class="value">{{reportInfo.application_department}}</span>
            </div>
            <div>
              <span class="label">送诊医生:</span>
              <span class="value">{{reportInfo.delivery_doctor}}</span>
            </div>
            <!-- <div>
              <span class="label">申请医生:</span>
              <span class="value">{{reportInfo.clin_doctors_name}}</span>
            </div>-->
            <!-- <div>
              <span class="label">病区:</span>
              <span class="value">{{reportInfo.patient_area}}</span>
            </div>-->
          </div>
        </section>
        <section class="reportInfo">
          <div class="reportDetails reportInfoBottom">
            <div>
              <span class="label">检查部位:</span>
              <span class="value">{{reportInfo.body_part}}</span>
            </div>
            <!-- <div>
              <span class="label">检查号:</span>
              <span class="value">{{reportInfo.accession_num}}</span>
            </div>
            <div>
              <span class="label">申请科室:</span>
              <span class="value">{{reportInfo.application_department}}</span>
            </div>-->
            <!-- <div></div>
            <div></div>-->
          </div>
        </section>
        <!-- <section class="reportInfo">
          <div class="reportDetails reportInfoBottom">
            <div>
              <span class="label">检查方法:</span>
              <span class="value">{{reportInfo.exam_project}}</span>
            </div>
          </div>
        </section>-->
        <section class="result">
          <div>
            <span class="label">检查所见:</span>
            <br />
            <br />
            <span
              class="value"
              v-html="reportInfo.description"
            ></span>
          </div>
          <div style="margin-top: 6rem;">
            <span class="label">意见建议:</span>
            <br />
            <br />
            <span
              class="value"
              v-html="reportInfo.impression"
            ></span>
          </div>
        </section>
        <footer class="footer">
          <section class="docter">
            <span v-if="reportInfo.dr_use_autograph != 1">报告医师：{{reportInfo.report_doctor_name}}</span>
            <span
              class="reportDoctor"
              v-if="reportInfo.dr_use_autograph == 1"
            >
              报告医师：
              <img
                :src="reportDoctorImg"
                alt
              />
            </span>
            <span v-if="reportInfo.dv_use_autograph != 1">审核医师：{{reportInfo.review_doctor_name}}</span>
            <span
              class="reviewDoctor"
              v-if="reportInfo.dv_use_autograph == 1"
            >
              审核医师：
              <img
                :src="reviewDoctorImg"
                alt
              />
            </span>
          </section>
          <section class="time">
            <span class="span1">本检查结果仅反应受检者当时的情况，仅供临床医师参考</span>
            <span class="span2">报告日期：{{reportInfo.report_datetime}}</span>
          </section>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { getPaperReport } from '@/api/reportOuter'
export default {
  name: 'print',
  data() {
    return {
      loading: true,
      exam_id: '',
      reportInfo: {
        hospital: '',
        modality: '',
        accession_num: '',
        exam_datetime: '',
        name: '',
        sex: '',
        age: '',
        application_department: '',
        patient_num: '',
        hopitalized_no: '',
        bed_no: '',
        clin_doctors_name: '',
        exam_project: '',
        impression: '',
        description: '',
        reviewDoctor: '',
        reportDoctor: '',
        reportDate: '',
        patient_area: '',
        body_part: '',
        delivery_doctor: ''
      },
      reportDoctorImg: '',
      reviewDoctorImg: ''
    }
  },
  methods: {
    suofang(id) {
      let oWidth = window.screen.width //获取当前手机屏幕宽度
      let num //css中固定的网页宽度
      if (oWidth < 411) {
        num = 794
      } else if (oWidth >= 411 && oWidth < 540) {
        num = 880
      } else if (oWidth >= 540) {
        num = 1300
      }
      let objId = document.getElementsByClassName('contnet')[0] //获取传入的id标签对象
      let rate = oWidth / num //缩放比例 = 当前手机屏幕宽度/css中固定的网页宽度

      if (oWidth < 1920) {
        objId.style.transformOrigin = 'left top 0px'
        objId.style.transform = 'scale(' + rate + ')'
        /* IE 9 */
        objId.style.msTransformOrigin = 'left top 0px'
        objId.style.msTransform = 'scale(' + rate + ')'
        /* Safari and Chrome */
        objId.style.webkitTransformOrigin = 'left top 0px'
        objId.style.webkitTransform = 'scale(' + rate + ')'
        /* Firefox */
        objId.style.mozTransformOrigin = 'left top 0px'
        objId.style.mozTransform = 'scale(' + rate + ')'
        /* Opera */
        objId.style.oTransformOrigin = 'left top 0px'
        objId.style.oTransform = 'scale(' + rate + ')'
      }
    },
    async initData() {
      let res = await getPaperReport({ id: this.exam_id })
      if (res) {
        this.reportInfo = res
        let exam_datetime = this.reportInfo.exam_datetime
        this.reportInfo.exam_datetime =
          exam_datetime.substring(0, 4) +
          '年' +
          exam_datetime.substring(4, 6) +
          '月' +
          exam_datetime.substring(6) +
          '月'
        if (this.reportInfo.dv_use_autograph == 1) {
          if (this.reportInfo.dv_autograph != null) {
            this.reviewDoctorImg =
              'https://risserver3.pacsonline.cn' + this.reportInfo.dv_autograph
          }
        }
        if (this.reportInfo.dr_use_autograph == 1) {
          if (this.reportInfo.dr_autograph != null) {
            this.reportDoctorImg =
              'https://risserver3.pacsonline.cn' + this.reportInfo.dr_autograph
          }
        }
      }
    },
    closeFn() {
      this.$router.go(-1)
    }
  },
  mounted() {
    this.exam_id = this.$route.query.exam_id
    this.suofang('body')
    this.initData()
  }
}
</script>
<style scoped lang="scss">
.pageContent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'songti';
  background: #606368;
  text-align: left;
  // padding-top: 1.5rem;
  .contnet {
    width: 794px;
    height: 1123px;
    background: #606368;
    padding-top: 2rem;
    .close {
      width: 64px;
      height: 64px;
    }
    div {
      width: 94%;
      background: #ffffff;
      margin: 0 auto;
      height: 90%;
      position: relative;
      .header {
        padding-top: 1rem;
        width: 90%;
        margin: 0 auto;
        position: relative;
        .image {
          z-index: 99999;
          position: absolute;
          top: 0.5rem;
        }
        .CTNum {
          position: absolute;
          bottom: 0.1rem;
          right: 0;
          z-index: 99999;
          margin: 0;
        }
        .hospital {
          width: 100%;
          font-weight: bold;
          padding: 0.2rem 0 0.1rem 0;
          font-size: 20px;
          display: flex;
          justify-content: center;
        }
        .reportCard {
          width: 100%;
          padding: 0 0 0.2rem 0;
          font-size: 18px;
          display: flex;
          justify-content: center;
        }
      }
      .reportDetails {
        width: 90%;
        margin: 0 auto;
        font-size: 14px;
        .checkDetails {
          width: 100%;
          border-top: 0.01rem solid #000;
          padding-top: 0.1rem;
          display: flex;
          span {
            width: 50%;
          }
        }
      }
      .reportInfo {
        width: 90%;
        height: 0.6rem;
        line-height: 0.6rem;
        margin: 0 auto;
        font-size: 5px;
        .reportDetails {
          width: 100%;
          display: flex;
          padding-top: 0.2rem;
          div {
            width: 25%;
            display: flex;
            line-height: 0.3rem;

            .label {
              display: block;
            }
          }
        }
        .reportInfoBottom {
          width: 100%;
          display: flex;
          padding: 0.1rem 0;
          border-bottom: 0.01rem solid #000;
          div {
            margin: 0;
          }
        }
      }
      .result {
        width: 90%;
        min-height: 14rem;
        margin: 0 auto;
        padding: 0.2rem 0;
        font-size: 14px;

        div {
          width: 100%;
          margin: 0.5rem 0;

          .label {
            font-size: 18px;

            font-weight: 600;
          }
          .value {
            padding: 0.1rem 0;
          }
        }
      }

      .footer {
        width: 90%;
        font-size: 14px;
        position: absolute;
        bottom: 0.2rem;
        left: 5%;
        .docter {
          width: 100%;
          display: flex;
          // height: 0.35rem;
          line-height: 1rem;
          justify-content: space-between;
          .reviewDoctor {
            justify-content: space-between;
            img {
              width: 2rem;
              height: 1rem;
            }
          }
          .reportDoctor {
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
              width: 2rem;
              height: 1rem;
            }
          }
        }
        .time {
          width: 100%;
          display: flex;
          line-height: 1rem;
          border-top: 0.01rem solid #000;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>


